export default __webpack_public_path__ + "static/media/news101.9d794c73.jpg";